import React, { HTMLAttributes } from 'react'

import { Heading } from '@hhgtech/hhg-components'
import { Accordion, Text } from '@hhgtech/hhg-components/mantine'
import { useMantineTheme } from '@mantine/core'

import { ToolsInfoCard, ToolsInfoCardProps } from '../toolsInfoCard'
import { StyledFaqAccordion } from './index.styled'
import { useIsMobile } from 'hooks/useIsMobile'

export type FaqItem = {
  rawTitle?: string
  title: string | React.ReactNode
  description: string | React.ReactNode
}

type FaqAccordionProps = {
  faqs: Array<FaqItem>
  title?: string
  template?: 'category' | 'health-tool' | 'due-date'
  titleProps?: ToolsInfoCardProps
  dataEventCategory?: string
  dataEventAction?: string
  dataEventLabel?: (faq: FaqItem) => string
  bgContentColor?: string
} & HTMLAttributes<HTMLDivElement>
export const FaqAccordion = ({
  faqs,
  title,
  template = 'health-tool',
  titleProps,
  dataEventCategory,
  dataEventAction,
  dataEventLabel,
  ...rest
}: FaqAccordionProps) => {
  const isMobile = useIsMobile()
  const theme = useMantineTheme()
  const borderColor = theme.colors.neutral[1]
  return (
    <StyledFaqAccordion
      borderColor={borderColor}
      data-template={template}
      {...rest}
    >
      <ToolsInfoCard
        headingTitle={
          title && (
            <Heading tag="h5" className="title-heading">
              {title}
            </Heading>
          )
        }
        icon={<></>}
        {...titleProps}
      >
        <Accordion className="accordion">
          {faqs.map((faq, index) => (
            <Accordion.Item key={index} value={String(index)}>
              <Accordion.Control
                data-event-category={dataEventCategory}
                data-event-action={dataEventAction}
                data-event-label={dataEventLabel?.(faq)}
                className="pointer-event-child-none"
              >
                {React.isValidElement(faq.title) ? (
                  faq.title
                ) : (
                  <Text as="span" size="p2">
                    {faq.title}
                  </Text>
                )}
              </Accordion.Control>
              <Accordion.Panel>
                {React.isValidElement(faq.description) ? (
                  faq.description
                ) : (
                  <Text as="div" size={isMobile ? 'p2' : 'p3'}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: faq.description as string,
                      }}
                    ></div>
                  </Text>
                )}
              </Accordion.Panel>
            </Accordion.Item>
          ))}
        </Accordion>
      </ToolsInfoCard>
    </StyledFaqAccordion>
  )
}
